/**
 * @fileoverview Texto de um CSV lido como ArrayBuffer (FileReader.readAsArrayBuffer).
 *
 * - BOM de UTF-16 (FF FE / FE FF) ou de UTF-8 (EF BB BF): usa a codificação
 *   dele, como o readAsText fazia (o Bloco de Notas salva "Unicode" em UTF-16).
 * - Sem BOM: UTF-8, se os bytes forem UTF-8 válido.
 * - Senão, Windows-1252 (ANSI), como o Excel no Brasil salva "CSV (separado
 *   por vírgulas)". Lido como UTF-8, "Assistência" virava "Assist�ncia".
 *   Exceção: UTF-8 com um ou outro byte quebrado (mais letras acentuadas certas
 *   do que quebradas) continua UTF-8, para não estragar o arquivo inteiro.
 */
export const decodeCsvText = (buffer) => {
  const bytes = new Uint8Array(buffer);
  if (bytes[0] === 0xff && bytes[1] === 0xfe) return new TextDecoder("utf-16le").decode(bytes);
  if (bytes[0] === 0xfe && bytes[1] === 0xff) return new TextDecoder("utf-16be").decode(bytes);
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch (err) {
    const utf8 = new TextDecoder("utf-8").decode(bytes);
    const broken = (utf8.match(/\uFFFD/g) || []).length;
    const accented = (utf8.match(/[\u0080-\uFFFC\uFFFE\uFFFF]/g) || []).length;
    return accented > broken ? utf8 : new TextDecoder("windows-1252").decode(bytes);
  }
};
